"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStateSlice = void 0;
const pinia_1 = require("pinia");
exports.useStateSlice = (0, pinia_1.defineStore)("state", {
    state() {
        return {
            id: -1,
            name: ""
        };
    }
});
